import { all, select, put, takeEvery } from 'redux-saga/effects';
import docCookies from 'cookies-js';
import { REHYDRATE } from 'redux-persist-immutable/constants';

import analytics from '../../lib/analytics';
import support from '../../lib/support';
import logging from '../../lib/logging';

import { success } from '../../lib/Actions';
import * as selectors from './selectors';
import * as SessionActions from './actions';

function handleAuthSuccess({ payload: { token, currentUserId, email } }) {
  docCookies.set('BEARER', token, { expires: Infinity });
  logging.setUser(currentUserId);
  analytics.identify({ id: currentUserId });
  support.identify({ email });
}

function handleDeauthRequest() {
  docCookies.expire('BEARER');
  logging.setUser(); // Clears user context
  analytics.identify();
  support.identify({ email: undefined });
}

function* rehydrated() {
  const currentUserId = yield select(selectors.currentUserId);
  const email = yield select(selectors.email);
  logging.setUser(currentUserId);
  analytics.identify({ id: currentUserId });
  support.identify({ email });
  yield put(success(SessionActions.INITIALIZE)());
}

export default function* defaultSaga() {
  yield all([
    takeEvery(SessionActions.AUTH.SUCCESS, handleAuthSuccess),
    takeEvery(SessionActions.DEAUTH.REQUEST, handleDeauthRequest),
    takeEvery(SessionActions.DEAUTH.SUCCESS, handleDeauthRequest),
    takeEvery(REHYDRATE, rehydrated),
  ]);
}
